export default __webpack_public_path__ + "static/char-v-21-jam-d0d9134a552e9d3d0867670034442c31.mp4";